// Enregistrer ici chaque contrôleur : application.register('nom', NomController).
// Un contrôleur qui tire une dépendance propre aux pages publiques s'enregistre
// dans entrypoints/out.js.
import application from './application';
import AlertController from './alert_controller';
import AppRedirectController from './app_redirect_controller';
import BlogCategoriesController from './blog_categories_controller';
import DropdownController from './dropdown_controller';
import EmailSuggestionController from './email_suggestion_controller';
import FAQVoteController from './faq_vote_controller';
import LocaleSwitchController from './locale_switch_controller';
import ModalController from './modal_controller';
import TabsController from './tabs_controller';
import ThemeController from './theme_controller';
import VideoSoundController from './video_sound_controller';

application.register('alert', AlertController);
application.register('app-redirect', AppRedirectController);
application.register('blog-categories', BlogCategoriesController);
application.register('dropdown', DropdownController);
application.register('email-suggestion', EmailSuggestionController);
application.register('faq-vote', FAQVoteController);
application.register('locale-switch', LocaleSwitchController);
application.register('modal', ModalController);
application.register('tabs', TabsController);
application.register('theme', ThemeController);
application.register('video-sound', VideoSoundController);
